import { connect } from "react-redux";
import React, { useEffect, useState } from 'react';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import * as logger from '../../../../logger';
import {
    DialogTitle,
    Paper,
    Grid,
    Button,
    ExpansionPanelDetails,
    Dialog,
    DialogContent,
    DialogActions,
    IconButton,
    InputAdornment,
    Card,
    CardContent,
    Typography,
} from '@material-ui/core';
import { driverBookCss as useStyles } from '../VehicleCss';
import RightSideBar from '../../../components/RightSideBar/RightSideBar';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteExpenseDialog from '../../../components/VehicleDialogs/DeleteExpenseDialog';
import { numberFormat, getDateInStringDocumentDDMMMYYYY, getVehicleNumberValuesDWeb, numberFormatComma, getTripDateFilterValues, getDateStringDDMMM } from '../../../../utils/utils';
import { PandL, Expenses, singleTruck, getVehicleMaintenanceConfig, fetchOtherExpensesBook, FetchExpenseDetails } from '../../../../store/actions/vehicleActionCreator';
import DateFilter from "../../../components/FilterComponent/DateFilter";
import CustomDateFilterDialog from '../../../components/FilterComponent/CustomDateFilter';
import ExpenseTypeFilter from '../../../components/FilterComponent/ExpenseTypeFilter';
import { DriverExpensesIcon } from '../../../../components/icons';
import AddDriverExpenseDialog from '../../../components/VehicleDialogs/AddDriverExpenseDialog';
import { trackDwebEvent } from '../../../analytics';

const DriverBook = ({ open, onClose, vehicle, dispatchGetDriverBook, dispatchFetchSingleExpense, dispatchGetPandL, dispatchGetTripExpenses }) => {

    let submit, formValues;

    const [onOpen, setOnOpen] = useState(null);
    const [dateFilterValue, setDateFilterValue] = useState("ALL_MONTHS");
    const [changeFlag, setChangeFlag] = useState(false);
    const [singleExpenseDetails, setSingleExpenseDetails] = useState({});
    const [expenseFilterValue, setExpenseFilterValue] = useState("All_Expense");
    const [driverBookDetails, setDriverBookDetails] = useState({});
    const [vehicleNumberType, setVehicleNumberType] = useState({ vehicleNumberPrefix: "", vehicleNumberSuffix: "" })
    const [addDriverExpenseDialogOpen, setAddDriverExpenseDialogOpen] = useState(false);
    const [editExpenseDialog, setEditExpenseDialog] = useState(false);
    const [expenseIdValue, setExpenseIdValue] = useState("");
    const [deleteExpenseDialogOpen, setDeleteExpenseDialogOpen] = useState(false);
    const [customFilter, setCustomFilter] = useState(false);
    const [customFilterValue, setCustomFilterValue] = useState({});

    const classes = useStyles();

    let location = useLocation();
    let path = location && location.pathname ? location.pathname.split("/") : [];
    let vehicleId = path && path[path.length - 1] ? path[path.length - 1] : "";

    var dateFilterValueUtil = getTripDateFilterValues();

    useEffect(() => {
        if (driverBookDetails && driverBookDetails.vehicleId) {
            trackDwebEvent("Dweb SVP Other Expenses", {
                vehicle_id: vehicleId,
                vehicle_number: driverBookDetails && driverBookDetails.vehicleNumber ? driverBookDetails.vehicleNumber : "",
                total_fuel_expense: driverBookDetails && driverBookDetails.totalCost ? driverBookDetails.totalCost : ""
            });
        }
    }, [driverBookDetails]);

    useEffect(() => {
        let startDateRange = dateFilterValueUtil[dateFilterValue].startDateRange;

        let driverData = {
            vehicleId: Number(vehicleId),
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            },
            expenseType: []
        }

        dispatchGetDriverBook(driverData, null,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Driver Book", "Get driver book successfull");
                    setOnOpen(true);
                }
            },
            () => {
                logger.log("Driver Book", "Get driver book failed")
            }
        );
    }, [open]);


    useEffect(() => {
        if (vehicle.truckBooks) {
            setDriverBookDetails(vehicle.truckBooks);
            const vehicleNumberArray = getVehicleNumberValuesDWeb(vehicle.truckBooks.vehicleNumber);
            if (vehicleNumberArray && vehicleNumberArray.length > 0) {
                const vehicleNumberSuffixValue = vehicleNumberArray.pop();
                const vehicleNumberPrefixValue = vehicleNumberArray.join("");

                setVehicleNumberType({
                    vehicleNumberPrefix: vehicleNumberPrefixValue,
                    vehicleNumberSuffix: vehicleNumberSuffixValue,
                })
            }
        }

        if (vehicle.singleExpenseDetails) {
            setSingleExpenseDetails(vehicle.singleExpenseDetails)
        }

    }, [vehicle.truckBooks, vehicle.singleExpenseDetails, vehicle.maintenanceUpcoming]);

    useEffect(() => {

        if (changeFlag) {
            let startDateRange = dateFilterValueUtil[dateFilterValue].startDateRange;

            let driverData = {
                vehicleId: Number(vehicleId),
                startDateRange: {
                    startTimeEpoch: startDateRange.startTimeEpoch,
                    endTimeEpoch: startDateRange.endTimeEpoch
                }
            }

            if (expenseFilterValue == "All_Expense") {
                driverData.expenseType = []
            } else {
                driverData.expenseType = [expenseFilterValue]
            }

            if (customFilterValue && customFilterValue.startTimeEpoch) {
                driverData.startDateRange = customFilterValue;
            }

            dispatchGetDriverBook(driverData, null,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log("Driver Book", "Get driver book successfull");
                    }
                },
                () => {
                    logger.log("Driver Book", "Get driver book failed")
                }
            );
        }

    }, [dateFilterValue, expenseFilterValue, customFilterValue]);


    const recall = () => {

        var startDateRange = dateFilterValueUtil["ALL_MONTHS"].startDateRange;

        var PandLdata = {
            vehicleId: Number(vehicleId),
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            }
        };

        var expenseData = {
            vehicleId: Number(vehicleId),
            startDateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            },
            expenseParentType: []
        };


        let driverData = {
            vehicleId: Number(vehicleId),
            dateRange: {
                startTimeEpoch: startDateRange.startTimeEpoch,
                endTimeEpoch: startDateRange.endTimeEpoch
            },
            expenseType: []
        }

        let defaultDateFilterValue = "ALL_MONTHS";
        let defaultTripBookFilterValue = "All Trips & Expenses";
        let defaultExpenseTypeFilter = "All Expense";

        dispatchGetDriverBook(driverData, defaultExpenseTypeFilter,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Driver Book", "Get driver book successfull");
                    dispatchGetPandL(PandLdata, defaultDateFilterValue,
                        (data) => {
                            if (data && data.status && data.status.code == 200) {
                                logger.log("Driver Book Dweb", "Get P and L report Successfull");
                                dispatchGetTripExpenses(expenseData, defaultTripBookFilterValue,
                                    (data) => {
                                        if (data && data.status && data.status.code == 200) {
                                            logger.log("Driver Book Dweb", "Get Trip Expenses report Successfull");
                                            setDateFilterValue("ALL_MONTHS");
                                            setExpenseFilterValue("All_Expense");
                                        }
                                    },
                                    () => {
                                        logger.log("Driver Book Dweb", "Get Trip Expenses report Failed");
                                    },
                                )
                            }
                        },
                        () => {
                            logger.log("Driver Book Dweb", "Get P and L report Failed");
                        },
                    )
                }
            },
            () => {
                logger.log("Driver Book", "Get driver book failed")
            }
        );
    }

    const handleAddDriverExpense = () => {
        trackDwebEvent("Dweb SVP Fuel Book Expense Initiated", {
            vehicle_id: vehicleId,
            vehicle_number: driverBookDetails && driverBookDetails.vehicleNumber ? driverBookDetails.vehicleNumber : "",
            total_fuel_expense: driverBookDetails && driverBookDetails.totalCost ? driverBookDetails.totalCost : ""
        });
        setSingleExpenseDetails({});
        setAddDriverExpenseDialogOpen(true);
    }

    const handleAddDriverExpenseClose = () => {
        setAddDriverExpenseDialogOpen(false);
        setEditExpenseDialog(false);
        setSingleExpenseDetails({});
    }


    const handleExpenseConfirm = () => {
        setAddDriverExpenseDialogOpen(false);
        setEditExpenseDialog(false);
        setSingleExpenseDetails({});
        recall();
    }

    const onConfirm = () => {
        setOnOpen(false);
        onClose();
    }

    const handleDateValue = (value) => {
        if (value == "CUSTOM") {
            setCustomFilter(true);
        }
        else {
            setDateFilterValue(value);
            setCustomFilter(false);
            setCustomFilterValue({});
        }
        setChangeFlag(true);
    }

    const handleExpenseTypeFilter = (value) => {
        setExpenseFilterValue(value);
        setChangeFlag(true);
    }

    const handleEditExpense = (expenseId) => {
        setEditExpenseDialog(true);
        setExpenseIdValue(expenseId);
        dispatchFetchSingleExpense(expenseId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Driver Book Dweb", "Get single expense details successfull");
                    setAddDriverExpenseDialogOpen(true);
                }
            },
            () => {
                logger.log("Driver Book Dweb", "Get single expense details failed");
            }
        );
    }

    const handleDeleteExpense = (expenseId) => {
        setExpenseIdValue(expenseId);
        setDeleteExpenseDialogOpen(true);
    }

    const handleDeleteClose = () => {
        setDeleteExpenseDialogOpen(false);
    }

    const handleDeleteExpenseConfirm = () => {
        setDeleteExpenseDialogOpen(false);
        recall();
    }


    const handleCustomFilterClose = () => {
        setCustomFilter(false);
    }

    const handleCustomFilterConfirm = (value) => {
        setDateFilterValue("CUSTOM");
        setCustomFilter(false);
        setCustomFilterValue(value);
    }

    return (
        <>
            {onOpen && <RightSideBar
                sideBarName="driver-other-expenses"
                rightSideBarOpen={onOpen}
                sideBarTitle={'Driver & Other Expenses'}
                sideBarType="truckBook"
                vehicleNumberValue={vehicleNumberType}
                truckType={driverBookDetails && driverBookDetails.vehicleBodyType ? driverBookDetails.vehicleBodyType : ""}
                handleSubmit={event => submit(event)}
                addExpense={handleAddDriverExpense}
                toggleRightSideBar={onConfirm} >

                {driverBookDetails.totalCount == 0 &&
                    <>
                        <div className={classes.divEmptyState}>
                            <DriverExpensesIcon className={classes.driverBookIcon} />
                            <div className={classes.emptyState}>Add your Driver and other expenses to get <div>Monthly Truck Profit</div></div>
                        </div>
                    </>
                }

                {driverBookDetails.totalCount > 0 &&
                    <>
                        <div className={classes.divFilter}>
                            <div>
                                <div className={classes.dateRange}>Date Range</div>
                                <DateFilter dateValue={handleDateValue} fromSingleVehicle={true} defaultValue={dateFilterValue} />
                            </div>
                            <div className={classes.mlV2}>
                                <div className={classes.dateRange}>Expense Type</div>
                                <ExpenseTypeFilter fromDriverBook={true} filterValue={handleExpenseTypeFilter} />
                            </div>
                        </div>

                        <div className={classes.marginV1}>
                            <Card className={classes.brV1}>
                                <CardContent className={classes.cardContentV1}>
                                    <div>
                                        <div className={classes.titleV1}>Total Cost</div>
                                        <div className={classes.totalRevenue}>{driverBookDetails && (driverBookDetails.totalCost || driverBookDetails.totalCost == 0) ? numberFormat(driverBookDetails.totalCost) : driverBookDetails.totalCost}</div>
                                    </div>
                                </CardContent>
                            </Card>
                        </div>

                        {
                            (driverBookDetails && driverBookDetails.otherExpenseItems) &&
                            <>
                                <div className={classes.mbV1}>
                                    {
                                        driverBookDetails.otherExpenseItems.map((driver) => (
                                            <>

                                                < div className={classes.divMonth}>
                                                    {driver.month}
                                                </div>
                                                {
                                                    driver.lineItems.map((items) => (

                                                        <>
                                                            < div className={classes.mtV2}>
                                                                <Card className={classes.brV1}>
                                                                    <CardContent className={classes.cardContentV4}>
                                                                        <div>
                                                                            <div className={classes.divV6}>
                                                                                <div className={classes.fsV1}>
                                                                                    {items.expenseName &&
                                                                                        <>
                                                                                            <div>{items.expenseName}</div>
                                                                                        </>
                                                                                    }
                                                                                </div>

                                                                                <div className={classes.displayFlex}>
                                                                                    <div>
                                                                                        <IconButton className={classes.pV1} onClick={() => handleEditExpense(items.id)}><EditIcon className={classes.editIcon} /></IconButton>
                                                                                    </div>
                                                                                    <div className={classes.mlV1}>
                                                                                        <IconButton className={classes.pV1} onClick={() => handleDeleteExpense(items.id)}><DeleteIcon className={classes.deleteIcon} /></IconButton>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            {items.tripId &&
                                                                                <div className={classes.divFromATrip}>
                                                                                    <div className={classes.fromATrip}>From a trip</div>
                                                                                </div>
                                                                            }
                                                                            <div className={classes.divV2}>
                                                                                <div>
                                                                                    <span>{getDateStringDDMMM(items.expenseDate)}</span>
                                                                                </div>
                                                                                <div className={classes.divAmount}>
                                                                                    {numberFormat(items.amount)}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </CardContent>
                                                                </Card>
                                                            </div>
                                                        </>
                                                    ))
                                                }
                                            </>
                                        ))
                                    }
                                </div>
                            </>
                        }
                    </>
                }
            </RightSideBar>
            }

            {addDriverExpenseDialogOpen && <AddDriverExpenseDialog open={addDriverExpenseDialogOpen} onClose={handleAddDriverExpenseClose} onConfirm={handleExpenseConfirm} driverExpenseData={singleExpenseDetails} edit={editExpenseDialog} expenseId={expenseIdValue} />}
            {deleteExpenseDialogOpen && <DeleteExpenseDialog open={deleteExpenseDialogOpen} onClose={handleDeleteClose} onConfirm={handleDeleteExpenseConfirm} expenseParentType={"other"} expenseId={expenseIdValue} />}
            {customFilter && <CustomDateFilterDialog open={customFilter} onClose={handleCustomFilterClose} onConfirm={handleCustomFilterConfirm} />}

        </>
    )
}

const mapStateToProps = (state) => ({ vehicle: state.vehicle });
const mapDispatchToProps = (dispatch) => ({
    dispatchGetDriverBook: (data, defaultExpenseTypeFilter, onSuccess, onFailure) => {
        dispatch(fetchOtherExpensesBook(data, defaultExpenseTypeFilter, onSuccess, onFailure))
    },
    dispatchFetchSingleExpense: (expenseId, onSuccess, onFailure) => dispatch(FetchExpenseDetails(expenseId, onSuccess, onFailure)),
    dispatchGetPandL: (data, defaultDateFilterValue, onSuccess, onFailure) => dispatch(PandL(data, defaultDateFilterValue, onSuccess, onFailure)),
    dispatchGetTripExpenses: (data, defaultTripBookFilterValue, onSuccess, onFailure) => dispatch(Expenses(data, defaultTripBookFilterValue, onSuccess, onFailure)),
})

export default (connect)(mapStateToProps, mapDispatchToProps)(DriverBook);
